
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/historical/cc-jl/chapter02",
      function () {
        return require("private-next-pages/docs/historical/cc-jl/chapter02/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/historical/cc-jl/chapter02"])
      });
    }
  